<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.99992 16.6667V11.6667"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.6666 13.3333L9.99992 11.6667L8.33325 13.3333"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.3333 16.6667H15.8333C16.2754 16.6668 16.6994 16.4912 17.012 16.1786C17.3246 15.8661 17.5001 15.4421 17.5 15V7.44999C17.5 6.52954 16.7538 5.78337 15.8333 5.78333H10.4408C10.1648 5.78332 9.90675 5.64663 9.75167 5.41833L8.58083 3.69749C8.42574 3.46973 8.16805 3.3334 7.8925 3.33333H4.16667C3.7246 3.33321 3.30061 3.50876 2.98802 3.82135C2.67543 4.13394 2.49988 4.55793 2.5 4.99999V15C2.49988 15.4421 2.67543 15.8661 2.98802 16.1786C3.30061 16.4912 3.7246 16.6668 4.16667 16.6667H6.66667"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
